import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BarChart3, PieChart, TrendingUp, Bell } from "lucide-react";
import Analytics from "../Analytics";
import Attribution from "../Attribution";
import Forecast from "../Forecast";
import Alerts from "../Alerts";
import { SectionHeader } from "./Capture";

const TABS = [
  { id: "analytics", label: "Analytics", icon: BarChart3, comp: Analytics, hint: "Revenue & AI performance" },
  { id: "attribution", label: "Attribution", icon: PieChart, comp: Attribution, hint: "Content → revenue mapping" },
  { id: "forecast", label: "Forecast", icon: TrendingUp, comp: Forecast, hint: "AI revenue projections" },
  { id: "alerts", label: "Alerts", icon: Bell, comp: Alerts, hint: "What needs your attention" },
];

export default function Intelligence() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "analytics";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || Analytics;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="intelligence-page">
      <SectionHeader title="Insights" subtitle="Decision-grade clarity on what's working" tabs={TABS} active={tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <Active />
    </div>
  );
}
